import type { FC } from "react";
import { Badge, Button, Group, Stack, Text, Title } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { getPatientLabelFirstLine, type Order } from "@jasper/shared";
import type { OrderPageState } from "../useOrderPage";
import { OrderDetailActions } from "./OrderDetailActions";
import {
  getOrderStatusBadge,
  getOrderStatusDateLabel,
  ICON_STROKE,
} from "./order-page-v2.utils";

export const OrderBackLink: FC = () => (
  <Button
    component={Link}
    to="/orders"
    variant="subtle"
    size="compact-sm"
    px={0}
    w="fit-content"
    leftSection={<IconChevronLeft size={14} stroke={ICON_STROKE} />}
  >
    Mes commandes
  </Button>
);

type OrderDetailHeaderProps = {
  order: Order;
  state: OrderPageState;
};

export const OrderDetailHeader: FC<OrderDetailHeaderProps> = ({
  order,
  state,
}) => {
  const { isAwaitingDentistReview } = state.design;
  const statusBadge = getOrderStatusBadge(order, isAwaitingDentistReview);
  const statusDateLabel = isAwaitingDentistReview
    ? null
    : getOrderStatusDateLabel(order);

  return (
    <Group justify="space-between" align="flex-start" gap="s4">
      <Stack gap="s2">
        <Title order={1} variant="display" size="lg">
          {order.patient ? (
            <>
              Commande de{" "}
              <Text span inherit variant="accent">
                {getPatientLabelFirstLine(order)}
              </Text>
            </>
          ) : (
            `Commande ${order.orderReference}`
          )}
        </Title>
        <Group gap="s2">
          <Text size="sm">Référence</Text>
          <Text variant="numeric">{order.orderReference}</Text>
          <Badge color={statusBadge.color}>{statusBadge.label}</Badge>
          {statusDateLabel && <Text size="sm">{statusDateLabel}</Text>}
        </Group>
      </Stack>
      <Group gap="s3">
        <OrderDetailActions state={state} />
      </Group>
    </Group>
  );
};
